import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'

export const getLegsProgressOutcomes = (
  historyCoupon: KambiHistoryCoupon | BetLoopKambiShareCoupon
): KambiHistoryCoupon['outcomes'] => {
  const couponRows = historyCoupon.couponRows.filter(({ index }) =>
    historyCoupon.bets[0].couponRowIndexes.includes(index)
  )

  return couponRows.flatMap(orderLegsStatusOutcomesByCouponRow(historyCoupon))
}

// =============
// Local Helpers
// =============

const orderLegsStatusOutcomesByCouponRow =
  (historyCoupon: KambiHistoryCoupon | BetLoopKambiShareCoupon) =>
  (couponRow: KambiHistoryCoupon['couponRows'][number]) => {
    if (couponRow.selectionType === 'BET_BUILDER' && couponRow.outcomeGroup) {
      const firstOutcomeId = couponRow.outcomeGroup.groups[0]?.outcomeIds[0]
      const outcome = historyCoupon.outcomes.find(o => o.outcomeId === firstOutcomeId)
      return outcome ? [outcome] : []
    }

    const outcome = historyCoupon.outcomes.find(o => o.outcomeId === couponRow.outcomeId)
    return outcome ? [outcome] : []
  }
